var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2728 39.4828H3.76188C1.68844 39.4828 0 37.7358 0 35.5905V4.45277C0 2.30749 1.68844 0.560547 3.76188 0.560547H22.0995C22.2979 0.560547 22.4904 0.642649 22.6315 0.788608L31.8142 10.2911C31.9553 10.437 32.0347 10.6347 32.0347 10.8415V35.5906C32.0347 37.7358 30.3462 39.4828 28.2728 39.4828L28.2728 39.4828ZM3.76188 2.11744C2.51722 2.11744 1.50475 3.16499 1.50475 4.45277V35.5905C1.50475 36.8783 2.51722 37.9259 3.76188 37.9259H28.2713C29.5159 37.9259 30.5284 36.8783 30.5284 35.5905V11.1637L21.7865 2.11744H3.76188Z",
    fill: "#74E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2832 11.6204H22.1001C21.6842 11.6204 21.3477 11.2722 21.3477 10.8419V1.33902C21.3477 0.90872 21.6842 0.560547 22.1001 0.560547C22.5159 0.560547 22.8525 0.908732 22.8525 1.33902V10.0634H31.2847C31.7006 10.0634 32.0371 10.4116 32.0371 10.8419C32.0356 11.2707 31.6991 11.6204 31.2832 11.6204H31.2832Z",
    fill: "#74E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0948 20.9539H6.94378C6.52791 20.9539 6.19141 20.6057 6.19141 20.1754C6.19141 19.7451 6.52792 19.397 6.94378 19.397H25.0948C25.5107 19.397 25.8472 19.7451 25.8472 20.1754C25.8472 20.6057 25.5107 20.9539 25.0948 20.9539Z",
    fill: "#74E8E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0948 26.2084H6.94378C6.52791 26.2084 6.19141 25.8602 6.19141 25.4299C6.19141 24.9997 6.52792 24.6515 6.94378 24.6515H25.0948C25.5107 24.6515 25.8472 24.9997 25.8472 25.4299C25.8472 25.8602 25.5107 26.2084 25.0948 26.2084Z",
    fill: "#74E8E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0948 31.4628H6.94378C6.52791 31.4628 6.19141 31.1146 6.19141 30.6843C6.19141 30.2541 6.52792 29.9059 6.94378 29.9059H25.0948C25.5107 29.9059 25.8472 30.2541 25.8472 30.6843C25.8472 31.1146 25.5107 31.4628 25.0948 31.4628Z",
    fill: "#74E8E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.bf74006a.svg";
export { ForwardRef as ReactComponent };